/*
    Vessels are created by the user and stored on device.
    Vessels need to be validated against remote PSMFC server
*/

export class VesselData {

    // Unique identifier for this vessel
    vesselID: string = '';

    vesselName: string = '';

    vesselCoastNumber: string = '';

    isRecognized: boolean = false;

    constructor(vname: string, vcoastNum: string) {
        this.vesselName = vname;
        this.vesselCoastNumber = vcoastNum;
    }

    toString(): string {
        return this.vesselName + ' - ' + this.vesselCoastNumber;
    }

    isValid(): boolean {
        return (this.vesselName != '' && this.vesselCoastNumber != '');
    }


    static transformAnonymous(anon: any[]): VesselData[] {
        let list: VesselData[] = [];
        anon.forEach(v => {
            let item = new VesselData(v.vesselName, v.vesselCoastNumber);
            item.isRecognized = v.isRecognized;
            item.vesselID = v.vesselID;
            list.push(item);
        });
        return list;
    }
}
